import React from "react";
import "./style.css";

interface MessageBalloonProps {
  text: string;
  pointed?: boolean;
  answer?: boolean;
  url?: string;
}

export const MessageBalloon: React.FC<MessageBalloonProps> = ({
  text,
  pointed = false,
  answer = false,
  url
}) => {
  return (
    <div className={["balloon", pointed && "pointed", answer && "answer"].filter(Boolean).join(" ")}>
      {url ? <a href={url}>{text}</a> : <>{text}</>}
    </div>
  );
};
